import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box,
    Button
} from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

import DateFilter from '@inovua/reactdatagrid-community/DateFilter'

import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import DataGridToolbar from '../../common/DataGridToolbar';
import DataGridTable from '../../common/DataGridTable';
import { CommonIcons, icons } from "../../common/CommonIcons";
import CommonRestricted from '../../common/CommonRestricted';

import { useItems, itemTypes, targetTypes } from '../../../hooks/api/useItems';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useDataGridParams } from '../../../hooks/useDataGridParams';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';
import { useTranslations } from '../../../hooks/useTranslations';

export default function ListCategories({
    routeType
}) {

    const { t } = useTranslations({ ns: ["common", "@product"] })

    const navigate = useNavigate();

    const { promptMessage } = useSystemPrompt();
    const { list, remove, filterOperatorTypes } = useItems({ itemType: itemTypes.category, targetType: targetTypes.category });

    const [ selectedIds, setSelectedIds ] = useState([])
    const [ refreshDataGrid, setRefreshDataGrid ] = useState(0)
    // const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay } = useDataGridParams('id')
    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.product.id, scopeTypes.product.category.id)

    const gridRef = React.createRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try{

            props.dataTypes = ["child_count"]

            props.filterValue = [
                {
                    name: "parent_category_id",
                    operator: filterOperatorTypes.eq,
                    value: "0"
                }
            ]
            props.sortInfo = {
                id: 'ax_createdatetime',
                dir: -1
            }

            const result = await list(props)

            return {
                data: result?.data?.item_categories,
                count: result?.data?.total
            }

        }catch(error){

            promptMessage(false, `Error getting results (${error?.message})`)
            
            return {
                data: [],
                count: 0
            }
        }  
        
    }

    useEffect (()=>{

        defineColumnsView()
        
    }, [])    

    const defineColumnsView = () => {

        defineColumns ([
            { 
                name: 'name', 
                header: t('categoryName'), 
                renderValue: ({ value, cellProps }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`products/category/update/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)
                }
            },
            { 
                name: 'description', 
                header: t('description')
            },
            { 
                name: 'child_count', 
                header: t('subCategory'),
                renderValue: ({ value, cellProps }) => {

                    const props = {
                        size: 'small',
                        variant: 'outlined',
                    }

                    if(parseInt(value, 10)){

                        return getRenderColumnTextDisplay(`${value} ${t('children')}`)
                    
                    }

                    return <></>
                    

                    // if(parseInt(value, 10)){
                        
                        // return (
                        
                        //     <Button 
                        //         {...props}
                        //         // fullWidth
                        //         onClick={() => {

                        //             if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                        //                 return getRenderColumnTextDisplay(value)
                        //             }
                                    
                        //             navigate(getRoute(`products/category/update/${cellProps.data.id}`))

                        //             return true;

                        //         }}
                        //     >
                        //         {parseInt(value, 10)}
                                
                        //     </Button>
                        // )
                    // }

                    // if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                    //     return <></>
                    // }

                    // return (
                    //     <Button 
                    //         {...props} 
                    //         onClick={() => {

                    //             navigate(getRoute(`products/category/update/${cellProps.data.id}`))

                    //         }}
                    //     >
                    //         <CommonIcons textAlign="right" name={icons.add} />
                    //     </Button>
                    // )

                }  
            },
            { 
                name: 'status', 
                header: t('status'), 
                defaultFlex: 1, 
                showColumnMenuTool: false,
                renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay(value, [t('enabled'), t('disabled')], ["primary", "default"], "")
            },
        ])

    }

    const handleDelete = async () => {

        try{
            let result = await remove({ ids: selectedIds })

            promptMessage(true, result?.message)
            setRefreshDataGrid(val => val+1)

        }catch(error){
            promptMessage(false, error?.message)
        }

    }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.plus,
                    onClick: () => {

                        navigate(getRoute("products/category/new"));
                        
                    }
                })
            }

            return props
        }

        const getActionOnClick = () => {

            let handleFunction = null

            if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
                handleFunction = handleDelete
            }

            return handleFunction
        }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                actionOnClickRemove={
                    getActionOnClick()
                }
                actionMenus={[]}
            />
        )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    checkboxColumn: 
                        isPermissionAllow({ functionType: functionTypes.remove.id }),
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        // console.log('items selected : ', items)
                        setSelectedIds(
                            items
                        )
                    }
                }}
                
            />
        )

    }

    return (
        <Box>
            {  
                getHtmlHead({ routeType, title: headTitles.categories })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('categories')}
                breadcrumbs={[
                    {
                        displayText: t('categories'),
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
